export default __webpack_public_path__ + "static/media/Aunshon_Developer.eb7fdd1f.pdf";